module.exports = __webpack_public_path__ + "static/viber_chat_prod-a25f1caeb831c9345da2aac9f3bf7364.png";